import { FlexBox } from '@airship-platform/jam-web/components';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

interface SyncStatusSectionProps {
  options: {
    name: string;
    optionId: string;
    estimateUrls: string[];
    errors: string[];
  }[];
}

const SyncStatusSection: React.FC<SyncStatusSectionProps> = ({ options }) => {
  const renderExternalLinks = (usls: string[], showPending: boolean) =>
    usls.length ? (
      usls.map((url) => (
        <Typography
          variant="body2"
          key={url}
          component={Link}
          href={url}
          target="_blank"
        >
          Launch ServiceTitan
        </Typography>
      ))
    ) : showPending ? (
      <Typography variant="body2" color="warning">
        Pending Sync, please check back here shortly
      </Typography>
    ) : null;

  return (
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      {options.map((option) => (
        <FlexBox
          key={option.optionId}
          flexDirection={'column'}
          gap={1}
          width={'100%'}
        >
          <Divider flexItem sx={{ mb: 1 }} />
          <Typography variant="h4">{option.name}</Typography>
          {renderExternalLinks(option.estimateUrls, !option.errors.length)}
          {!!option.errors.length && (
            <>
              <Divider flexItem sx={{ visibility: 'hidden' }} />
              <Alert severity="error" variant="outlined">
                {option.errors.join(', ')}
              </Alert>
            </>
          )}
        </FlexBox>
      ))}
    </FlexBox>
  );
};

export default SyncStatusSection;
